var render, staticRenderFns
import script from "./sold_to_party.vue?vue&type=script&lang=js&"
export * from "./sold_to_party.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d7f84fe')) {
      api.createRecord('4d7f84fe', component.options)
    } else {
      api.reload('4d7f84fe', component.options)
    }
    
  }
}
component.options.__file = "found/views/kms_new/views/sold_to_party/sold_to_party.vue"
export default component.exports